import { Colors } from '@/components/ui/types';
import { UserStatusEnum } from '@/models/User';

export const studentStatusColors: Record<UserStatusEnum, Colors> = {
  [UserStatusEnum.ACTIVE_ENROLLMENT]: 'success',
  [UserStatusEnum.WAITING_ENROLLMENT]: 'warning',
  [UserStatusEnum.REGISTRED]: 'secondary',
  [UserStatusEnum.INACTIVE]: 'neutral',
};
